(() => {
  const init = () => {
    if (document.documentElement.classList.contains('aos-init')) return;
    document.documentElement.classList.add('aos-init');

    const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      // Respect reduced motion: reveal immediately
      document.querySelectorAll('[data-aos], .aos').forEach((el) => el.classList.add('inview'));
      return;
    }

    const observed = new WeakSet();
    const threshold = 0.15;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('inview');
            io.unobserve(e.target);
          }
        });
      },
      { threshold }
    );

    const isInViewport = (el) => {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const hVisible = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      const vRatio = hVisible / Math.max(1, r.height);
      const wVisible = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
      const wRatio = wVisible / Math.max(1, r.width);
      return vRatio >= threshold && wRatio > 0;
    };

    const apply = (root = document) => {
      const explicit = root.querySelectorAll?.('[data-aos], .aos') || [];
      const mediaWithContent = root.querySelectorAll?.('.media-with-content .media-block, .media-with-content .image-block, .media-with-content .media-with-content__content, .media-with-content .group-block-content') || [];
      const eventCards = root.querySelectorAll?.('.event-card, .resource-list__item .event-card') || [];
      const iconColumns = root.querySelectorAll?.('.icons-with-text .column, .icons-with-text [class*=\"icon\" i], .icons-with-text [class*=\"column\" i], .icon-block, .icon-block + *') || [];
      const groupBlocks = root.querySelectorAll?.('.group-block-content') || [];
      // Opt-in scopes: add .aos to all direct children of any .aos-scope container and apply optional stagger via class aos-stagger-XXX
      const scopes = root.querySelectorAll?.('.aos-scope') || [];
      scopes.forEach((scope) => {
        const stepClass = [...scope.classList].find((c) => /^aos-stagger-\\d+$/i.test(c));
        const step = stepClass ? parseInt(stepClass.replace(/[^0-9]/g, ''), 10) || 80 : 0;
        let i = 0;
        scope.childNodes.forEach((n) => {
          if (n.nodeType === 1) {
            /** @type {HTMLElement} */ (n).classList.add('aos');
            if (step) /** @type {HTMLElement} */ (n).style.transitionDelay = `${Math.min(i, 12) * step}ms`;
            i++;
          }
        });
      });
      // Built-in scope for Image with text: cascade image then content
      const iwtScopes = root.querySelectorAll?.('.media-with-content') || [];
      iwtScopes.forEach((scope) => {
        const items = scope.querySelectorAll('.image-block, .media-block, .media-with-content__content, .group-block-content');
        let i = 0;
        items.forEach((el) => {
          /** @type {HTMLElement} */ (el).classList.add('aos');
          /** @type {HTMLElement} */ (el).style.transitionDelay = `${Math.min(i, 12) * 120}ms`;
          i++;
        });
      });
      const targets = new Set([...explicit, ...mediaWithContent, ...eventCards, ...iconColumns, ...groupBlocks]);
      // Add cascading delays to icon blocks within the same container
      const iconBlocksList = root.querySelectorAll ? root.querySelectorAll('.icon-block') : [];
      iconBlocksList.forEach((blk, i) => {
        blk.classList.add('aos');
        blk.style.transitionDelay = `${Math.min(i, 12) * 120}ms`;
        const sib = blk.nextElementSibling;
        if (sib && sib.classList) {
          sib.classList.add('aos');
          sib.style.transitionDelay = `${Math.min(i, 12) * 120 + 60}ms`;
        }
        targets.add(blk);
        if (sib) targets.add(sib);
      });
      targets.forEach((el) => {
        if (!el.classList.contains('aos')) el.classList.add('aos');
        // Force a reflow to ensure transition picks up when we add .inview quickly
        // eslint-disable-next-line no-unused-expressions
        el.offsetWidth;
        if (!observed.has(el)) {
          observed.add(el);
          if (isInViewport(el)) {
            // Defer to next frame so CSS .aos is applied before .inview
            requestAnimationFrame(() => el.classList.add('inview'));
          } else {
            io.observe(el);
          }
        }
      });
    };

    // Initial pass
    apply(document);

    // Watch for dynamically added sections/cards
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes?.forEach?.((node) => {
          if (node.nodeType === 1) apply(/** @type {Element} */ (node));
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


